import { SessionWithId } from '../Models/session';

export const isSessionToday = (sessionWithId: SessionWithId): boolean => {
    const currentDate = new Date();

    const sessionDate = new Date(
        sessionWithId.session.year,
        sessionWithId.session.month - 1, // Month is 0-based in JavaScript Date
        sessionWithId.session.day,
    );

    // Compare only the year, month, and day parts of the dates
    return (
        sessionDate.getFullYear() === currentDate.getFullYear() &&
        sessionDate.getMonth() === currentDate.getMonth() &&
        sessionDate.getDate() === currentDate.getDate()
    );
};
